import React from 'react';
import {Formik, Form, Field} from 'formik';

import ChatInput from './chatInput';
import {useSendUserChat} from './hooks';
import DotsLoading from 'components/loadings/dotsLoading';
import ButtonGroup from './buttonGroup';

interface ChatInputAreaProps {
  chatId?: string;
  refresh: () => void;
  onWatchEnd: () => void;
}
const ChatInputArea = ({chatId, refresh}: ChatInputAreaProps) => {
  const {mutate, isLoading} = useSendUserChat({
    refresh,
  });

  return (
    <div className="rounded fixed py-4 max-h-[120px] z-20 w-full   bg-white  bottom-0 flex justify-center  items-center shadow-[0_-3.28779px_6.57558px_rgba(171,190,209,0.3)]">
      <Formik
        initialValues={{
          text: '',
        }}
        onSubmit={(values, actions) => {
          chatId &&
            mutate({
              chat_guid: chatId,
              text: values.text,
              clearInput: actions.resetForm,
            });
        }}
      >
        {({values}) => {
          return (
            <Form className="flex items-center gap-2 w-full justify-center ">
              <div className=" flex justify-center items-center h-full w-[10%]">
                {isLoading ? (
                  <DotsLoading />
                ) : (
                  <ButtonGroup text={values.text} />
                )}
              </div>

              <div className=" flex text-black items-center justify-center gap-2 w-[80%] ">
                <Field name="text" placeholder="پیام..." as={ChatInput} />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ChatInputArea;
